const template = require('./splash-screen.html');

export default {
    template
};



// WEBPACK FOOTER //
// ./app/common/splash-screen/splash-screen.component.js